import * as React from 'react';
import { observer } from 'mobx-react';
import { Button, EButtonType } from '../../../components/action';
import { ECheckoutStatus } from '../../../../../common/interfaces/checkout';

// Styles
const s = require('./PortalCheckout.css');

// Props
interface IPortalCheckoutVINMissingProps {
    onApprove: () => void;
    onDeclined: () => void;
}

// Component
@observer
export class PortalCheckoutVINMissing extends React.Component<IPortalCheckoutVINMissingProps, {}> {
    private VINMissingText: string =
    `It looks like you’re about to confirm your parts order without providing a VIN.
    Please note that all parts ordered incorrectly may be subject to a 20% restocking fee.
    Please go back to add VIN or click confirm to proceed.`;

    public render() {
        return (
            <div className={s.vinMissing}>
                <p>{this.VINMissingText}</p>
                <Button
                    inBox={true}
                    type={EButtonType.Important}
                    onClick={this.handleVINMissingDeclined}
                >
                    {'Let me add VIN'}
                </Button>
                <Button
                    inBox={true}
                    type={EButtonType.Action}
                    onClick={this.handleVINMissingApproval}
                >
                    {'I understand, proceed'}
                </Button>
            </div>
        );
    }

    private handleVINMissingApproval = () => {
        this.props.onApprove();
    };

    private handleVINMissingDeclined = () => {
      this.props.onDeclined();
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutVINMissing.tsx